<template lang="pug">
	.teams-table__block
		TableRow(
			:data="getChannelOne"
			:info="info"
			:isUpdate="isUpdate"
		)
		TableRow(
			:data="getChannelTwo"
			:info="info"
			:isUpdate="isUpdate"
		)
		TableRow(
			:data="getChannelTree"
			:info="info"
			:isUpdate="isUpdate"
		)
		TableRow(
			:data="getChannelFour"
			:info="info"
			:isUpdate="isUpdate"
		)



</template>

<script>
import SlideUpDown from 'vue-slide-up-down';
import TableRow from './TableRow';
import InlineSocials from '@/components/InlineSocials';

export default {
  components: {
    TableRow,
    InlineSocials,
    SlideUpDown
  },
  props: ['data', 'isUpdate', 'info'],
  computed: {
    getChannelOne() {
      if (typeof this.data.length === 'undefined') {
        return [];
      }

      const arr = this.data
        .filter(el => el.channelId === 0)
        .map(el => {
          if (!el.profit || isNaN(el.profit)) {
            el.profit = '';
          }
          return el;
        });
      arr.unshift({
        ...arr[0],
        weekId: -1,
        profit: arr[0].channel
      });

      return arr;
    },
    getChannelTwo() {
      if (typeof this.data.length === 'undefined') {
        return [];
      }
      const arr = this.data
        .filter(el => el.channelId === 1)
        .map(el => {
          if (!el.profit || isNaN(el.profit)) {
            el.profit = '';
          }
          return el;
        });

      arr.unshift({
        ...arr[0],
        weekId: -1,
        profit: arr[0].channel
      });
      return arr;
    },
    getChannelTree() {
      if (typeof this.data.length === 'undefined') {
        return [];
      }
      const arr = this.data
        .filter(el => el.channelId === 2)
        .map(el => {
          if (!el.profit || isNaN(el.profit)) {
            el.profit = '';
          }
          return el;
        });

      arr.unshift({
        ...arr[0],
        weekId: -1,
        profit: arr[0].channel
      });
      return arr;
    },
    getChannelFour() {
      if (typeof this.data.length === 'undefined') {
        return [];
      }
      const arr = this.data
        .filter(el => el.channelId === 3)
        .map(el => {
          if (!el.profit || isNaN(el.profit)) {
            el.profit = '';
          }
          return el;
        });

      arr.unshift({
        ...arr[0],
        weekId: -1,
        profit: arr[0].channel
      });
      return arr;
    }
  }
};
</script>
